import { render, staticRenderFns } from "./manageList.vue?vue&type=template&id=039bd00b&scoped=true&"
import script from "./manageList.vue?vue&type=script&lang=js&"
export * from "./manageList.vue?vue&type=script&lang=js&"
import style0 from "./manageList.vue?vue&type=style&index=0&id=039bd00b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039bd00b",
  null
  
)

export default component.exports